import { forwardRef } from 'react'

import CheckboxFormik from './_components/checkbox-formik'
import CheckboxGroupFormik from './_components/checkbox-group-formik'
import DateFormik from './_components/date-formik'
import FileInputFormik from './_components/file-formik'
import InputFormik from './_components/input-formik'
import InputPasswordFormik from './_components/input-password-formik'
import NumberFormik from './_components/number-formik'
import OtpFormik from './_components/otp-formik'
import PhoneFormik from './_components/phone-formik'
import RadioGroupFormik from './_components/radio-group-formik'
import SelectAutoCompleteFormik from './_components/select-auto-complete-formik'
import SelectFormik from './_components/select-formik'
import TextareaFormik from './_components/textarea-formik'
import type { ControlType, FormikControlProps } from './types'

const COMPONENT_MAP = new Map<ControlType, React.FC<any>>([
  ['text', InputFormik],
  ['email', InputFormik],
  ['password', InputPasswordFormik],
  ['select', SelectFormik],
  ['checkbox', CheckboxFormik],
  ['select-auto-complete', SelectAutoCompleteFormik],
  ['radio-group', RadioGroupFormik],
  ['checkbox-group', CheckboxGroupFormik],
  ['textarea', TextareaFormik],
  ['file', FileInputFormik],
  ['date', DateFormik],
  ['number', NumberFormik],
  ['otp', OtpFormik],
  ['phone', PhoneFormik],
])

const FormikControl = forwardRef<HTMLInputElement, FormikControlProps>((props, ref) => {
  const { control, ...rest } = props
  const Component = COMPONENT_MAP.get(control)

  return Component ? <Component {...rest} ref={ref} /> : null
})

FormikControl.displayName = 'FormikControl'

export default FormikControl
